/* eslint-disable */

import { v4 as uuid } from "uuid";

//File for constants

export const userProfileDetailsTabCategories = ["Tweets", "Likes"];

export const CLOUDINARY_URL =
  "https://api.cloudinary.com/v1_1/dbe8yf165/auto/upload";
export const CLOUDINARY_UPLOAD_PRESET = "twitlyx";

export const userAvatarOptions = [
  {
    id: uuid(),
    src: "https://res.cloudinary.com/dbe8yf165/image/upload/v1688910762/twitlyx/dog_viuaxu.png.png",
  },
  {
    id: uuid(),
    src: "https://res.cloudinary.com/dbe8yf165/image/upload/v1688910762/twitlyx/spiderman_manspe.png",
  },
  {
    id: uuid(),
    src: "https://res.cloudinary.com/dbe8yf165/image/upload/v1688910762/twitlyx/woman_ffwgy3.png",
  },
  {
    id: uuid(),
    src: "https://res.cloudinary.com/dbe8yf165/image/upload/v1688910762/twitlyx/batman_tbfknf.png",
  },
  {
    id: uuid(),
    src: "https://res.cloudinary.com/dbe8yf165/image/upload/v1688910762/twitlyx/arab-woman_yi6pi5.png",
  },
  {
    id: uuid(),
    src: "https://res.cloudinary.com/dbe8yf165/image/upload/v1688910762/twitlyx/chewing-gum_pvd8tx.png",
  },
  {
    id: uuid(),
    src: "https://res.cloudinary.com/dbe8yf165/image/upload/v1688910761/twitlyx/hacker_orjaqy.png",
  },
  {
    id: uuid(),
    src: "https://res.cloudinary.com/dbe8yf165/image/upload/v1688910761/twitlyx/superhero_1_fkjt3p.png",
  },
];
